import React from "react";
import styled from "styled-components";
import { func, node, object as obj } from "prop-types";
import Button from "components/shared/Button";
import Copy from "components/shared/Copy";
import Input from "components/shared/Input";
import TextArea from "components/shared/TextArea";
import LightBox from "components/shared/LightBox";
import { phoneLink } from "global/analytics";

const QueryForm = styled.form`
  background: white;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 20px;
  border-radius: 5px;
  max-width: 360px;
`;

const CareSolvedQueryForm = ({
  formState,
  formValues,
  submitQuery,
  toggleOpen,
  updateValues
}) => {
  const border = "1px solid #80808026";
  return (
    <LightBox open={toggleOpen}>
      <QueryForm onSubmit={submitQuery}>
        <Copy size={0.7} align="center">
          We will get back to you within 48 hours. Please complete all
          information to submit.
        </Copy>
        <Input
          border={border}
          id="full_name"
          onChange={updateValues}
          placeholder="My name is..."
        />
        <Input
          border={border}
          id="phone"
          onChange={updateValues}
          placeholder="My phone number is..."
        />
        <TextArea
          border={border}
          id="message"
          onChange={updateValues}
          placeholder="My question is..."
        />
        <Button
          background="viPink"
          disabled={Object.values(formValues).some(value => !value)}
          type="submit"
          label="Send Question"
          width="150px"
        />
        {formState === "error" && (
          <Copy color="statusRed" size={0.6} weight={700}>
            Submission failed. Please call us on{" "}
            {phoneLink("808 196 0909", { color: "inherit" })}.
          </Copy>
        )}
        {formState === "success" && (
          <Copy color="statusGreen" size={0.6} weight={700}>
            Question submitted successfully!
          </Copy>
        )}
      </QueryForm>
    </LightBox>
  );
};

CareSolvedQueryForm.propTypes = {
  formState: node,
  formValues: obj.isRequired,
  submitQuery: func.isRequired,
  toggleOpen: func.isRequired,
  updateValues: func.isRequired
};

export default CareSolvedQueryForm;
